import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../../../Config';
import { customStyles } from '../../../../../../HelperFunctions';
import Select from "react-select"
import { useDispatch, useSelector } from 'react-redux';
import { getTaxMasterCountryStatesList } from '../../../../../../Redux/action/MasterAction';

const AddTaxMaster = ({
    show,
    handleClose,
    onSuccess,
    refresh,
    countryOptions,
    token,
    user_id,
}) => {
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({

        initialValues: {

            tax_code: '',
            tax_name: '',
            tax_category: '',
            tax_type: '',

            tax_description: '',

            effective_from: '',
            effective_to: '',

            country_id: '',
            state_id: '',
            // currency_id: '',

            rounding_method: '',

            tax_rate_percent: '',
            calculation_method: '',

            is_tax_inclusive: false,
            is_reverse_charge_applicable: false,

            tax_nature: '',
            itc_eligible: '',

            is_compound_tax: false,
            is_tax_on_freight: false,

            notes: '',

            current_status: 'DRAFT',

            created_by: Cookies.get("flexichain_user_id") || 1,
            admin_id: Cookies.get("flexichain_user_id") || 1,

            status: true,

        },

        onSubmit: async (values) => {

            setIsSubmitting(true);

            try {

                const payload = {
                    ...values,

                    country_id: Number(values.country_id || 0),
                    state_id: Number(values.state_id || 0),
                    currency_id: Number(values.currency_id || 0),

                    tax_rate_percent: values.tax_rate_percent
                        ? String(values.tax_rate_percent)
                        : "0",

                    is_tax_inclusive: Boolean(
                        values.is_tax_inclusive
                    ),

                    is_reverse_charge_applicable: Boolean(
                        values.is_reverse_charge_applicable
                    ),

                    is_compound_tax: Boolean(
                        values.is_compound_tax
                    ),

                    is_tax_on_freight: Boolean(
                        values.is_tax_on_freight
                    ),

                    status: Boolean(values.status),

                };

                const response = await fetch(
                    `${adminMainUrl}/api/account/tax-master`,
                    {
                        method: "POST",

                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": Cookies.get("token"),
                            user_id: Cookies.get("flexichain_user_id"),
                        },

                        body: JSON.stringify(payload),
                    }
                );

                const data = await response.json();

                if (response.ok) {

                    toast.success(
                        data?.msg || "Tax Master created successfully."
                    );

                    if (onSuccess) {
                        onSuccess();
                    }

                    if (refresh) {
                        refresh();
                    }

                    formik.resetForm();

                    handleClose();

                } else {

                    toast.error(
                        data?.msg ||
                        data?.message ||
                        "Unable to create Tax Master."
                    );

                    console.error(
                        "Error creating Tax Master:",
                        data
                    );
                }

            } catch (error) {

                console.error(
                    "Network error:",
                    error
                );

                toast.error(
                    "Something went wrong. Please try again."
                );

            } finally {

                setIsSubmitting(false);

            }

        },

    });

    let [stateOptions, setStateOptions] = useState([]);

    useEffect(() => {
        if (formik.values.country_id) {
            dispatch(getTaxMasterCountryStatesList(token, user_id, formik.values.country_id));
        } else {
            setStateOptions([]);
        }
    }, [formik.values.country_id]);

    const {
        loadingMasterTaxMasterCountryStates,
        MasterTaxMasterCountryStates,
        MasterTaxMasterCountryStatesError
    } = useSelector(state => state?.MasterReducer)

    useEffect(() => {
        if (MasterTaxMasterCountryStates) {
            let countryArr = MasterTaxMasterCountryStates.map(v => { return { value: v.id, label: v.name } });
            setStateOptions(countryArr);
        } else {
            setStateOptions([]);
        }
    }, [MasterTaxMasterCountryStates])

    return (

        <Offcanvas
            className="custom-offcanvas"
            show={show}
            onHide={handleClose}
            placement="end"
            style={{
                width: "850px"
            }}
        >

            {/* =========================================================
                HEADER
            ========================================================= */}

            <Offcanvas.Header closeButton>

                <Offcanvas.Title>
                    Add Tax Master
                </Offcanvas.Title>

            </Offcanvas.Header>


            <Offcanvas.Body>

                <form onSubmit={formik.handleSubmit}>

                    {/* =====================================================
                        BASIC TAX INFORMATION
                    ===================================================== */}

                    <div className="row">

                        {/* Tax Code */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="tax_code"
                                className="form-label"
                            >
                                Tax Code
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="tax_code"
                                name="tax_code"
                                placeholder="GST18"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.tax_code}
                            />

                        </div>


                        {/* Tax Name */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="tax_name"
                                className="form-label"
                            >
                                Tax Name
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="tax_name"
                                name="tax_name"
                                placeholder="GST @ 18%"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.tax_name}
                            />

                        </div>


                        {/* Tax Category */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="tax_category"
                                className="form-label"
                            >
                                Tax Category
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="tax_category"
                                name="tax_category"
                                value={formik.values.tax_category}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >

                                <option value="">
                                    -Select-
                                </option>

                                <option value="GST">
                                    GST
                                </option>

                                <option value="VAT">
                                    VAT
                                </option>

                                <option value="TDS">
                                    TDS
                                </option>

                                <option value="Other">
                                    Other
                                </option>

                            </select>

                        </div>


                        {/* Tax Type */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="tax_type"
                                className="form-label"
                            >
                                Tax Type
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="tax_type"
                                name="tax_type"
                                value={formik.values.tax_type}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >

                                <option value="">
                                    -Select-
                                </option>

                                <option value="Output Tax">
                                    Output Tax
                                </option>

                                <option value="Input Tax">
                                    Input Tax
                                </option>

                                <option value="Both">
                                    Both
                                </option>

                            </select>

                        </div>


                        {/* Tax Description */}

                        <div className="col-md-6 mb-3">

                            <label
                                htmlFor="tax_description"
                                className="form-label"
                            >
                                Tax Description
                            </label>

                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="tax_description"
                                name="tax_description"
                                placeholder="Goods and Services Tax @ 18 Percent"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.tax_description}
                            />

                        </div>


                        {/* Status */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="status"
                                className="form-label"
                            >
                                Status
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="status"
                                name="status"
                                value={
                                    formik.values.status
                                        ? "true"
                                        : "false"
                                }
                                onChange={(e) => {

                                    formik.setFieldValue(
                                        "status",
                                        e.target.value === "true"
                                    );

                                }}
                            >

                                <option value="true">
                                    Active
                                </option>

                                <option value="false">
                                    Inactive
                                </option>

                            </select>

                        </div>


                        {/* Effective From */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="effective_from"
                                className="form-label"
                            >
                                Effective From
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <input
                                type="date"
                                className="form-control form-control-sm"
                                id="effective_from"
                                name="effective_from"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.effective_from}
                            />

                        </div>


                        {/* Effective To */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="effective_to"
                                className="form-label"
                            >
                                Effective To
                            </label>

                            <input
                                type="date"
                                className="form-control form-control-sm"
                                id="effective_to"
                                name="effective_to"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.effective_to}
                            />

                        </div>


                        {/* Country */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="country_id"
                                className="form-label"
                            >
                                Country
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>


                            <Select
                                className='custom-selector'
                                options={countryOptions}
                                styles={customStyles}
                                name="country_id"
                                onChange={option => formik.setFieldValue('country_id', option.value)}
                                value={countryOptions.find(option => option.value == formik.values.country_id || null)}
                            />

                        </div>


                        {/* State */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="state_id"
                                className="form-label"
                            >
                                State
                            </label>

                            <Select
                                className='custom-selector'
                                options={stateOptions}
                                styles={customStyles}
                                name="state_id"
                                onChange={option => formik.setFieldValue('state_id', option.value)}
                                value={stateOptions.find(option => option.value == formik.values.state_id || null)}
                            />

                        </div>


                        {/* Currency */}

                        {/* <div className="col-md-3 mb-3">

                            <label
                                htmlFor="currency_id"
                                className="form-label"
                            >
                                Currency
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="currency_id"
                                name="currency_id"
                                value={formik.values.currency_id}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >

                                <option value="">
                                    -Select Currency-
                                </option>

                                <option value="1">
                                    INR - Indian Rupee
                                </option>

                                <option value="2">
                                    USD - US Dollar
                                </option>

                            </select>

                        </div> */}


                        {/* Rounding Method */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="rounding_method"
                                className="form-label"
                            >
                                Rounding Method
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="rounding_method"
                                name="rounding_method"
                                value={formik.values.rounding_method}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >

                                <option value="">
                                    -Select-
                                </option>

                                <option value="Normal Rounding">
                                    Normal Rounding
                                </option>

                                <option value="Round Up">
                                    Round Up
                                </option>

                                <option value="Round Down">
                                    Round Down
                                </option>

                            </select>

                        </div>

                    </div>


                    <hr className="my-3" />


                    {/* =====================================================
                        TAX RATE DETAILS
                    ===================================================== */}

                    <h6 className="mb-3 text-primary">
                        Tax Rate Details
                    </h6>


                    <div className="row">


                        {/* Tax Rate */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="tax_rate_percent"
                                className="form-label"
                            >
                                Tax Rate (%)
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <div className="input-group input-group-sm">

                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    className="form-control"
                                    id="tax_rate_percent"
                                    name="tax_rate_percent"
                                    placeholder="18.00"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={
                                        formik.values.tax_rate_percent
                                    }
                                />

                                <span className="input-group-text">
                                    %
                                </span>

                            </div>

                        </div>


                        {/* Calculation Method */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="calculation_method"
                                className="form-label"
                            >
                                Calculation Method
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="calculation_method"
                                name="calculation_method"
                                value={
                                    formik.values.calculation_method
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >

                                <option value="">
                                    -Select-
                                </option>

                                <option value="Percentage">
                                    Percentage
                                </option>

                                <option value="Fixed Amount">
                                    Fixed Amount
                                </option>

                            </select>

                        </div>


                        {/* Is Tax Inclusive */}

                        <div className="col-md-3 mb-3">

                            <div className="form-check mt-4">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_tax_inclusive"
                                    name="is_tax_inclusive"
                                    checked={
                                        formik.values.is_tax_inclusive
                                    }
                                    onChange={formik.handleChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="is_tax_inclusive"
                                >
                                    Is Tax Inclusive
                                </label>

                            </div>

                        </div>


                        {/* Reverse Charge */}

                        <div className="col-md-3 mb-3">

                            <div className="form-check mt-4">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_reverse_charge_applicable"
                                    name="is_reverse_charge_applicable"
                                    checked={
                                        formik.values.is_reverse_charge_applicable
                                    }
                                    onChange={formik.handleChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="is_reverse_charge_applicable"
                                >
                                    Is Reverse Charge Applicable
                                </label>

                            </div>

                        </div>


                        {/* Tax Nature */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="tax_nature"
                                className="form-label"
                            >
                                Tax Nature
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="tax_nature"
                                name="tax_nature"
                                value={formik.values.tax_nature}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >

                                <option value="">
                                    -Select-
                                </option>

                                <option value="Both (Input & Output)">
                                    Both (Input & Output)
                                </option>

                                <option value="Input">
                                    Input
                                </option>

                                <option value="Output">
                                    Output
                                </option>

                            </select>

                        </div>


                        {/* ITC Eligible */}

                        <div className="col-md-3 mb-3">

                            <label
                                htmlFor="itc_eligible"
                                className="form-label"
                            >
                                ITC Eligible
                                <span
                                    className="text-danger"
                                >
                                    *
                                </span>
                            </label>

                            <select
                                className="form-control form-control-sm"
                                id="itc_eligible"
                                name="itc_eligible"
                                value={formik.values.itc_eligible}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >

                                <option value="">
                                    -Select-
                                </option>

                                <option value="Yes">
                                    Yes
                                </option>

                                <option value="No">
                                    No
                                </option>

                                <option value="Partial">
                                    Partial
                                </option>

                            </select>

                        </div>


                        {/* Is Compound Tax */}

                        <div className="col-md-3 mb-3">

                            <div className="form-check mt-4">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_compound_tax"
                                    name="is_compound_tax"
                                    checked={
                                        formik.values.is_compound_tax
                                    }
                                    onChange={formik.handleChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="is_compound_tax"
                                >
                                    Is Compound Tax
                                </label>

                            </div>

                        </div>


                        {/* Is Tax On Freight */}

                        <div className="col-md-3 mb-3">

                            <div className="form-check mt-4">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_tax_on_freight"
                                    name="is_tax_on_freight"
                                    checked={
                                        formik.values.is_tax_on_freight
                                    }
                                    onChange={formik.handleChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="is_tax_on_freight"
                                >
                                    Is Tax on Freight
                                </label>

                            </div>

                        </div>


                        {/* Notes */}

                        <div className="col-md-12 mb-3">

                            <label
                                htmlFor="notes"
                                className="form-label"
                            >
                                Notes
                            </label>

                            <textarea
                                rows="3"
                                className="form-control form-control-sm"
                                id="notes"
                                name="notes"
                                placeholder="Applicable for all taxable goods and services under GST @ 18%."
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.notes}
                            ></textarea>

                        </div>

                    </div>


                    {/* =====================================================
                        HIDDEN / SYSTEM VALUES
                    ===================================================== */}

                    <input
                        type="hidden"
                        name="current_status"
                        value={formik.values.current_status}
                    />

                    <input
                        type="hidden"
                        name="created_by"
                        value={formik.values.created_by}
                    />

                    <input
                        type="hidden"
                        name="admin_id"
                        value={formik.values.admin_id}
                    />


                    {/* =====================================================
                        FOOTER BUTTONS
                    ===================================================== */}

                    <div className="d-flex justify-content-end gap-2 mt-4">

                        <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            onClick={() => {

                                formik.resetForm();

                                handleClose();

                            }}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>


                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => {

                                formik.setFieldValue(
                                    "current_status",
                                    "DRAFT"
                                );

                                formik.handleSubmit();

                            }}
                            disabled={isSubmitting}
                        >

                            {isSubmitting ? (
                                <>
                                    <i className="fa fa-spinner fa-spin me-1"></i>
                                    Saving...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-save me-1"></i>
                                    Save Draft
                                </>
                            )}

                        </button>


                        <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            disabled={isSubmitting}
                            onClick={() => {

                                formik.setFieldValue(
                                    "current_status",
                                    "POSTED"
                                );

                                formik.handleSubmit();

                            }}
                        >

                            {isSubmitting ? (
                                <>
                                    <i className="fa fa-spinner fa-spin me-1"></i>
                                    Submitting...
                                </>
                            ) : (
                                "Submit"
                            )}

                        </button>

                    </div>

                </form>

            </Offcanvas.Body>

        </Offcanvas>

    );

};

export default AddTaxMaster;